<template>
  <div class="card">
    <div class="alert alert-warning mb-0" v-if="pass == 1">
      {{ t.creating_new_password }}
    </div>
    <div class="alert alert-success mb-0" v-if="pass && pass !== 1">
      <br>{{ t.new_password }}: <b><code>{{ pass.signature }}</code></b>
    </div>

    <div class="card-header">
      {{ user.fullName }}
      <div>
        <router-link :to="{name: 'CustomerUpdate', params: {id: this.$route.params.id}}" tag="a" class="btn btn-success text-white" style="margin-top:4px">{{ t.edit}}</router-link>
        <a class="btn btn-danger customer-reset-password text-white" href="javascript:;" style="margin-top:4px" @click="regenerateUserPass(user.id)">
          {{ t.reset_password }}</a>
        <a class="btn btn-success customer-payin text-white" href="javascript:;" @click="openPayinModal(user.id, '+')" style="margin-top: 4px">
          <i class="fa fa-plus-circle"></i> {{ t.custom_reseller_panel.balance_in }}
        </a>
        <a class="btn btn-danger customer-payout text-white" href="javascript:;" style="margin-top:4px" @click="openPayinModal(user.id, '-')">
          <i class="fa fa-minus-circle"></i> {{ t.custom_reseller_panel.balance_out }}
        </a>
        <a class="btn btn-warning customer-payout text-white" href="javascript:;" style="margin-top:4px" @click="openStakeModal(user.id)">
          <i class="fa fa-ticket"></i> {{ t.navigation.bet_slip_limits }}
        </a>
      </div>
    </div>
    <div class="card-block p-0">
      <div class="table-responsive">
        <table class="table mb-0 info">
          <tbody>
          <tr>
            <th>{{ t.user.groups.ROLE_RESELLER }}:</th>
            <td>{{ user.refUser }}</td>
            <th>Card:</th>
            <td>{{ user.username }}</td>
          </tr>
          <tr>
            <th>{{ t.created_at }}:</th>
            <td>
              <span>{{ dateTimeFormat(user.createdAt) }}</span>
            </td>
            <th>{{ t.user.last_login }}:</th>
            <td>
              <span>{{ dateTimeFormat(user.LastLogin) }}</span>
            </td>
          </tr>
          <tr>
            <th>{{ t.user.balance  }}:</th>
            <td colspan="2"><code>{{ user.balance }}</code>
              <a href="javascript:;" class="tag tag-danger CustomerBalance" @click="userDetail">{{ t.update }}</a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <StakeLimitModal />
    </div>
  </div>
</template>

<script>

  import PayinModal from "./PayinModal";
  import StakeLimitModal from "./StakeLimitModal.vue";
export default {
  name: "CustomerInfo",
  components: {PayinModal, StakeLimitModal},
  data() {
    return {
      user: {},
      session: session,
      t: this.$root.t,
      pass: null
    }
  },
  mounted() {
    this.userDetail();
  },
  methods: {
    userDetail() {
      this.$http.get(api + 'api/v1/users?uid=' + this.$route.params.id,
          {params: this.$route.query})
          .then(response => {
            this.user = response.body.result.users[0];
          }, response => {
            this.status = response.status;
          })
    },
    openPayinModal(user, operate) {
      this.$bus.$emit('payinModal', {id: user, action: true, operate: operate})
    },
    openStakeModal(user) {
      this.$bus.$emit('openStakeModal', {id: user, action: true})
    },
    regenerateUserPass(uid) {
      this.pass = 1;
        this.$http.post(api + 'api/v1/user/password-regeneration/' + uid)
            .then(response => {
                this.pass = response.body;

                setTimeout(() => {
                  this.pass = null
                }, 10000)
            }, response => {

              this.pass = null
            })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CustomerInfo.vue